import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';


@Injectable()
export class NgbDateParserFormatterService extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    const date = moment(value, 'DD/MM/YYYY');
    return {
      day: date.date(),
      month: date.month() + 1,
      year: date.year()
    };
  }

  format(date: NgbDateStruct): string {
    return date ? moment()
      .year(date.year)
      .month(date.month - 1)
      .date(date.day)
      .format('DD/MM/YYYY') : '';
  }
}
